(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86f2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86f2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9FaVK", function(module, exports) {

$parcel$export(module.exports, "events", function () { return events; });
parcelRequire("98bQa");
function toJqueryInstance(selector) {
    var $ = jQuery;
    if (!selector) return $();
    else if (selector instanceof $) return selector;
    else if (typeof selector === "string") return $("#" + selector);
    else return $(selector);
}
var UIEvents = function UIEvents(wrap, events, callback) {
    var $wrap = toJqueryInstance(wrap);
    if ($wrap && $wrap.length) {
        var bind = function bind() {
            var $el = jQuery(this), handler = $el.attr("data-event") || $el.attr("@event"), type = $el.attr("data-event-type") || $el.attr("@type"), event = {
                handler: null,
                type: null,
                data: {}
            }, obj;
            if (handler.indexOf("{") + 1 > 0 && handler.lastIndexOf("}")) {
                obj = eval("(" + handler + ")");
                event.handler = obj.handler || obj.action;
                event.type = obj.type;
                event.data = obj.data;
            } else {
                event.handler = handler;
                event.type = type;
            }
            if (events[event.handler]) $el.on(event.type || "click", event.data, function(e) {
                events[event.handler].call(events, this, e);
            }).removeAttr("data-event data-event-type @event");
        };
        $wrap.find("[data-event]").each(bind);
        $wrap.find('*:attrStartsWith("@event")').each(bind);
        callback && callback();
    }
};
var events = {
    bind: UIEvents
};

});
parcelRegister("98bQa", function(module, exports) {
var $6a5e0bac81dd2134$var$debugMode = 0, $6a5e0bac81dd2134$var$version = 3.2;
(function(global, factory) {
    if (!window) throw "Unable to start this plugin without window object";
    else if (typeof jQuery == "undefined") throw "Parsis JS unable to start without jQuery plugin";
    else factory(global);
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    jQuery.extend(jQuery.expr.pseudos, {
        attrStartsWith: function attrStartsWith(el, _, b) {
            for(var i = 0, atts = el.attributes, n = atts.length; i < n; i++){
                if (atts[i].nodeName.toLowerCase().indexOf(b[3].toLowerCase()) === 0) return true;
            }
            return false;
        }
    });
    var App = function App1(selector) {
        return new App.fn.init(selector);
    };
    App.fn = App.prototype = {
        init: function init(selector) {
            if (!selector) return jQuery();
            else if (selector instanceof jQuery) return selector;
            else if (typeof selector === "string") return jQuery("#" + selector);
            else return jQuery(selector);
        },
        search: function search(element) {
            var $wrap = jQuery(this);
            return $wrap.find('[data-element="' + element + '"]');
        }
    };
    App.fn.init.prototype = App.prototype;
    // Add custom app plugin to jQuery
    jQuery.fn.search = App.fn.search;
    jQuery.fn.validate = App.fn.validate;
    if (!noGlobal) window1.$$ = window1.Parsis = window1.General = App;
    console.log("PARSIS JS: Parsis JS is installed, version " + $6a5e0bac81dd2134$var$version);
    return App;
});

});



var $9FaVK = parcelRequire("9FaVK");
parcelRequire("98bQa");
var $0763bd23aff8ca1e$export$19196e6a79864442 = function SearchBarApp(config, $) {
    var app = this;
    var lastKeyChangedTimeout = 500;
    var lastKeyChanged = "";
    var lastKeyChangedTimeoutId = null;
    var ajax = null;
    app.elms = {};
    app.elms.$wrap = $$(config.wrapId);
    app.elms.$form = app.elms.$wrap.search("form");
    app.elms.$container = app.elms.$wrap.search("container");
    app.elms.$loading = app.elms.$wrap.search("loading");
    app.elms.$list = app.elms.$wrap.search("list");
    var components = new function() {
        var _component = this;
        _component.heading = function(title) {
            return '<div class="search-bar-heading"><strong>'.concat(title, "</strong></div>");
        };
        _component.item = function(data) {
            return '<div class="search-bar-item">\n                    <a href="'.concat(data.permalink, '" target="_blank" class="search-bar-item-label">').concat(data.title, "</a>\n                </div>");
        };
        _component.empty = function() {
            return '<p class="search-bar-empty"><i>No items found, please try with another keyword or filter.</i></p>';
        };
    };
    function search() {
        var data = app.elms.$form.serializeArray();
        data.push({
            name: "highlight",
            value: true
        });
        ajax && ajax.abort && ajax.abort();
        ajax = $.ajax({
            url: app.elms.$form.attr("action"),
            method: app.elms.$form.attr("method"),
            data: data,
            beforeSend: function() {
                app.elms.$loading.addClass("show");
            },
            complete: function() {
                app.elms.$loading.removeClass("show");
            },
            success: function(res) {
                app.elms.$list.html("");
                if (res && res.data) {
                    if (res.data.products) {
                        app.elms.$list.append(components.heading("Products: "));
                        for(var i in res.data.products)app.elms.$list.append(components.item(res.data.products[i]));
                    }
                    if (res.data.pages) {
                        app.elms.$list.append(components.heading("Pages: "));
                        for(var i1 in res.data.pages)app.elms.$list.append(components.item(res.data.pages[i1]));
                    }
                    if (res.data.posts) {
                        app.elms.$list.append(components.heading("Blog: "));
                        for(var i2 in res.data.posts)app.elms.$list.append(components.item(res.data.posts[i2]));
                    }
                } else app.elms.$list.html(components.empty());
                app.elms.$container.addClass("show");
            },
            error: function(e) {
                console.error(e);
            }
        });
    }
    app.keywordChanged = function(el, e) {
        if (e.type === "focus" || e.type === "click") {
            if (app.elms.$list.children().length) app.elms.$container.addClass("show");
            e.stopPropagation();
        } else if (el.value !== lastKeyChanged) {
            lastKeyChanged = el.value;
            lastKeyChangedTimeoutId = setTimeout(function() {
                search();
                clearTimeout(lastKeyChangedTimeoutId);
            }, lastKeyChangedTimeout);
        }
    };
    app.taxonomyChanged = function() {
        search();
    };
    app.init = function() {
        (0, $9FaVK.events).bind(app.elms.$wrap, app);
        $(document).on("click", function() {
            app.elms.$container.removeClass("show");
        });
        return app;
    };
};


var $18a2b6b723928a2b$var$careersSearchApp = new (0, $0763bd23aff8ca1e$export$19196e6a79864442)({
    wrapId: "search-bar"
}, jQuery).init();

})();
//# sourceMappingURL=app.js.map
